import { render } from "./NavbarBlank.vue?vue&type=template&id=4bed56ba"
const script = {}

import exportComponent from "/Users/sam/WebDev/Projects/debtnote/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__